import { Component, OnInit, OnDestroy } from '@angular/core';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';

import { RootState } from '../../root-store/root.state';
import { seLogoClick, seSetToolbarInfo } from '../../root-store/root.actions';
import { MainToolbarHeaderInfo } from './se-header-info/se-header-info.component';

@Component({
    selector: 'se-header-toolbar',
    templateUrl: './se-header-toolbar.component.html',
    styleUrls: ['./se-header-toolbar.component.scss'],
})
export class SeHeaderToolbarComponent implements OnDestroy, OnInit {
    info1: MainToolbarHeaderInfo;
    info2: MainToolbarHeaderInfo;

    private storeSubscriber: Subscription;

    constructor(
        private actions: Actions,
        private store: Store<RootState>,
    ) {}

    ngOnInit() {
        this.storeSubscriber = this.actions
            .pipe(ofType(seSetToolbarInfo))
            .subscribe(({ info1, info2 }) => this.setInfo(info1, info2));
    }

    ngOnDestroy() {
        this.info2 = undefined;
        this.info1 = undefined;

        this.storeSubscriber.unsubscribe();
    }

    async onLogoClick() {
        this.store.dispatch(seLogoClick());
    }

    private setInfo(info1: MainToolbarHeaderInfo, info2: MainToolbarHeaderInfo) {
        setTimeout(() => {
            this.info1 = info1;
            this.info2 = info2;
        });
    }
}
